module.exports = __webpack_public_path__ + "static_pc/img/18.ad481480.png";